<template>
  <b-container>
    <b-row>
      <b-col lg class="mb-4">
        <h1>Contact Us</h1>
        <p class="h3">Faith Christian Church Evansville WI</p>
        <p style="word-break: break-word;">
          <strong>Pastor:</strong> Jerry Dean
          <br />
          <strong>Service:</strong> 10am Sundays at
          <a
            href="https://maps.google.com/?q=845 Brown School Rd, Evansville, WI 53536"
            target="_blank"
          >845 Brown School Rd</a>
          <br />
          <strong>Phone:</strong>
          <a class="pl-1" href="tel:608-490-1004">608-490-1004</a>
          <br />
          <strong>Email:</strong>
          <a class="pl-1" href="mailto:jddean51@att.net">jddean51@att.net</a>
        </p>
        <iframe
          width="100%"
          height="400"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          allowfullscreen
          :src="google_map_src"
        />
      </b-col>
      <b-col lg>
        <contact-form />
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import ContactForm from "../components/ContactForm.vue";
import GoogleApiService from "../services/GoogleApiService";

export default {
  components: {
    ContactForm
  },
  metaInfo:{
    title: 'Faith Christian Church Evansville: Contact Us',
    description: 'Contact for for getting in touch with our church',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  computed: {
    google_map_src() {
      return `https://www.google.com/maps/embed/v1/place?key=${GoogleApiService.GetToken()}&q=place_id:${GoogleApiService.GetPlaceId()}`;
    }
  }
};
</script>

<style lang="scss" scoped>
strong {
  color: #f01614;
}

iframe {
  border: 1px solid #f01614;
  border-radius: 4px;
}
</style>